const getVersion = () => {
    return 'v7.1.2';
};

export default getVersion;
